var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLegalCase3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 129,
    viewBox: "0 0 127 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1701_3012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 31.1047C10 19.4489 19.4489 10 31.1047 10H87.2758C98.9317 10 108.381 19.4489 108.381 31.1047V88.8953C108.381 100.551 98.9317 110 87.2758 110H31.1047C19.4489 110 10 100.551 10 88.8953V31.1047Z",
    fill: "#FBF8F0"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 64,
    height: 64,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1701_3012",
    x: 0.151122,
    y: 0.151122,
    width: 126.521,
    height: 128.14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.03491,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1701_3012"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.22095,
    dy: 4.22095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.51746
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1701_3012"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1701_3012",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1701_3012",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1701_3012",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADX0lEQVR4nO2b3YtNURyGHx9jREkk/gLKjI9cSkS+uaNIypV/QMmFdNxRGs1kYrjR5MKdZpTIVyZ3kpsxlDAxiqvBDAYNS6uWm6mz91r7nH32PrPep946nc55z+9jr7XX2nsfEEIIIYQQQojyY1Ik1IDpjdEIUAOixmgEqAFRYzQC1ICoMRoBakDUGI0ANSAqTngc9dVUKTr4mJtQKTromJtQKTrYmJtQKTrImJtQKTq4mJtQKTqomJtQKTqYWDntJIQQQgghhBBRswroAp4D35zs606gXf750QpcBP4kXCybBLqBORH654oN/mHA9foHgUm0Nrl/7lzKcMfqQkT+uc/5ScM2aTi3ReCfO10Zgv+v8xH4585QDQkMRuCfO+M1JDAWgX/ujNWQwNcI/HOn2aeIoWafgjprSKAjAv/caXdLstDgJ4GVEfg3hO4MCXRF5J87dlt+PyD4e0BLRP4NYY7bnicN50l35LRE6N8w2twOcdCtscfd6446zZltTe4vhBBCCCGEEDWzANgDnAR6gFvArjrUdQmwCTgKnAP6gafu8vEwMAr8dhp17w25z/S779jvbnRetbIbuA1cAU4Be4GFFMRy4IxLdurW/XhGz/kuSbvVf5nh4liaXrhLz/Y35tXpv2k292fAWWAFDWAf8Aj4WyXJqxk81wG9wM8cil5NE8B1YEuGeHureNqaDAD7gRnUmdXOPCmpV4FH1k4Pz0boiYslZKS+TvG0ea2hThzzvGGx2dNvGXCzBIU3U9QHLPXMYZuH36SrXWZmBzwxdsfTcwPwqQTFNlX0EVjvmctdT097s2dWlgb0BARuj4g07Gd+lKDIJkXfPc8NOwI8bROCOBBgPuxx0rErhC8lKK7x1Ge30ktiJvA+wNOenL2YC3wIMLaPdCdhm/O4BEU1gRrwOLAuB/iNuKewUzkSGOjBFL/tJSimyaitKbkdCvQ77NOAvkBTu0RN4loJCmkyyq75k1gb6HfDpwEjgaaLUvzelqCQJqPepOS2ONDvnU8DfgWapj0hMFGCQpqMsrEn0RLoZ3f7qYQGWW8/UzI1ul6FB2hKJjUANUAjIAFNQWgKSqToKcToHFB8EY1OwsUX0mgV1JxKo95+hQdoSiY1gMgaIIQQQgghhBBCCCGYlvwDQJH2Xf7iyDYAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalCase3);
export default __webpack_public_path__ + "static/media/LegalCase3.6193465fa545c41572dc7a2c9da15fe6.svg";
export { ForwardRef as ReactComponent };